<template>
    <auction-dialog title="낙찰 수수료 안내" width="880" @open="init">
        <template #activator="{attrs,on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template #default>
            <p class="font-size-14 font-size-md-16">
                현재가 기준 <strong class="font-size-16 font-size-md-20 pl-8">{{ commission }}원</strong>
                <!-- <strong class="font-size-16 font-size-md-20 pl-8">{{ current }}</strong>(현재가) + <strong class="font-size-16 font-size-md-20 pl-8">{{ commission }}원</strong> (낙찰수수료) + <strong class="font-size-16 font-size-md-20 pl-8">{{ vat }}원</strong> (부가가치세) = <strong class="font-size-16 font-size-md-20 pl-8">{{ total }}원</strong> (구매가) -->
            </p>
            <div class="mt-6 mt-md-10">
                <v-card tile elevation="0" class="grey-ef">
                    <v-card-text class="pa-16 pa-md-24">
                        <ul class="dot-list">
                            <li>KATA 옥션의 낙찰 수수료는 5%입니다.</li>
                            <li>위의 수수료는 낙찰가격과 상관없이 일괄 적용합니다.</li>
                        </ul>
                    </v-card-text>
                </v-card>
            </div>
            <div class="mt-6 mt-md-10">
                <auction-commission-table></auction-commission-table>
            </div>
        </template>
    </auction-dialog>
</template>

<script>
import AuctionDialog from "./auction-dialog.vue";
import AuctionCommissionTable from "./auction-commission-table.vue";

export default {
    components: {
        AuctionDialog,
        AuctionCommissionTable,
    },
    props: {
        work: { type: Object, default: () => ({}) },
    },
    data: () => ({
    }),
    computed: {
        current() {
            return (this.work?.price_auction?.current || 0)?.format?.();
        },
        commission() {
            return (this.work?.price_auction?.commission || 0)?.format?.();
        },
        vat() {
            return (this.work?.price_auction?.vat || 0)?.format?.();
        },
        total() {
            return (this.work?.price_auction?.total || 0)?.format?.();
        },
    },
    methods: {
        async init() {
            this.$emit("refresh");
        },
    },
};
</script>